<template>

 


  <div class="content-box">

    <div v-if="showImg" class="img-view">
        <div @click="closeImg" class="img-layer"></div>
        <div class="img">
            <img :src="imgSrc">
        </div>
    </div>

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>搜索结果</el-breadcrumb-item>
                <el-breadcrumb-item>數據詳情</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="sub-line"></div>



    <div class="content">
      <div class="title">{{detaildata.gxsd_chinese_title}}</div>
      <div class="sc-xz-box">
        <div v-if="ifsc==0" @click="onclick_sc()">
          <i  class="el-icon-star-off"><span style="padding:0px 5px">收藏</span></i>
        </div>
        <div v-if="ifsc==1" @click="onclick_sc()">
          <i  class="el-icon-star-on"><span style="padding:0px 5px">收藏</span></i>
        </div>
        <div>
          <i class="el-icon-view"> <span style="padding:0px 5px">對比</span></i>
        </div>
      </div>
      <div class="xq-box">
          <span>詳情</span>
          <img src="../assets/icon/line.png">
      </div>
      <div class="xq-container">
    
        

        <div class="xq-row">
          <div class="xq-left">
            內容標題：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_content_title}}
          </div>
        </div>


        <div class="xq-row">
          <div class="xq-left">
            出版物所屬系列：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_pubulish_serial}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            出版物主要語言：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_main_language}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            出版物分類：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_publish_class}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            具體數據類型：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_data_class}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            出版物出版者：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_publisher}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            內容描述的具體港口名：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_port_name}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            出版物出版地：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_publish_addr}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            冊號：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_book_number}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            篇名（中文）：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_chinese_title}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            篇名（英文）：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_english_title}}
          </div>
        </div>
        <div class="xq-row">
          <div class="xq-left">
            地名：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_addr}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            相關人物：
          </div>
          <div class="xq-right">
            {{detaildata.gxsd_people}}
          </div>
        </div>

        <div class="xq-row">
          <div class="xq-left">
            頁碼：
          </div>
          <div class="xq-right">
            <span >
              {{firstpage(detaildata.gxsd_book_page)}};
             

            </span>
            
          </div>
        </div>


      </div>
      
      <div class="dzll-box">
        <span>對照瀏覽</span>
          <img src="../assets/icon/line.png">
      </div>

      <div class="dzll-container">
        <div class="dzll-img">
          
           <ul >
              <li v-for="i in mycount" style="list-style-type:none;" >
                <img @click="openImg" :src="i">
              </li>
            </ul>

        </div>
        <div v-if="detaildata.gxsd_content_alter!=''" class="dzll-input">
          <div v-html="detaildata.gxsd_content_alter" class="dzll_content">
          </div>
          
        </div>
        <div v-if="detaildata.gxsd_content_alter==''" class="dzll-input">
          <div v-html="detaildata.gxsd_content" class="dzll_content">
          </div>
          
        </div>
      </div>

      
    </div>
  </div>
</template>


         



<script>
//import FileSaver from '../lib/FileSaver.min.js';
//import BigImg from 'bigimg.vue';
export default {
  name: "app",
  data() {
    return {
      bid:this.$route.query.bid,
      ifsc:0,
      detaildata:[],
      pageArray:[],
      object:{},
      //totaldata:'99999',
      mycount: [],
      //hguser:window.sessionStorage.gsetItem('hguser'),
      //hguid:window.sessionStorage.getItem('hguid'),

      showImg:false,
      imgSrc:"",
    };
  },
  methods: {
    firstpage(info_pages){
      let fpage;
      let p_arr;
      if(info_pages){
        p_arr=info_pages.split(",");

      }
      
      if(p_arr.length>0){
        fpage=p_arr[0];
      }else{
        fpage="";
      }
      return fpage;

    },

    getJson() {
      let myid=this.detaildata.ID;
      let hguser=window.sessionStorage.getItem('hguser');
      let hguid=window.sessionStorage.getItem('hguid');
      
      this.object['bid'] =myid;//
      this.object['ustring'] =hguser;//
      this.object['uid'] =hguid;//


      let myjson = JSON.stringify(this.object);
      //alert(myjson);
      return myjson;    
    },
    onclick_sc(){
      
      

      let json = this.getJson();
      this.$http
        .post(`${this.$store.state.baseurl}/api/hghomescupdate`,json)
          .then((res) => {
            //alert(res);
            let json=JSON.parse(res.data);
            console.log(json);
           // alert(json);
            if(json.error=='1'){
              //this.ifsc=json.dataSize;
              
              this.$message({
                type: 'info',
                message: '请登錄！'
              });

            }
            
            this.ifsc=json.dataSize;
            
        
            //this.ifsc=json.scvalue;
            //this.ifsc=json.dataSize;
            //console.log('souchang:'+this.ifsc);
          },err=>{

        });

    },
    openImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
      //console.log("图片:"+this.imgSrc);
    },
    closeImg(){
      this.showImg = false;
    },
    
    //点击搜索按钮
    btnsearch(){

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
    setpage(p){
      let pa="";
      if(p<10){
        pa="0"+p;
      }
      else{
        pa=p;
      }

      return pa;
    },
  },
  created() {
    //获取当前条目ID号
    //let id = this.$route.params.id;
    this.$http.get(`${this.$store.state.baseurl}/api/hghomeDetail/getdetail?bid=`+this.bid).then(res=>{
        let json=JSON.parse(res.data);
        this.detaildata=json;
        let parr=this.detaildata.gxsd_book_page.split(",");
        console.log("入："+parr);
        for(var i=0;i<parr.length;i++){
          //console.log("入数组："+this.detaildata.pre10+this.setpage(parr[i]));
          let rpage=parseInt(parr[i])+parseInt(this.detaildata.pre8);
          //this.mycount.push(`${this.$store.state.sourceurl}`+this.detaildata.pre10+this.setpage(rpage+2)+".png");
          if(rpage>=0){
            this.mycount.push(`${this.$store.state.sourceurl}`+this.detaildata.pre10+this.setpage(rpage)+".png");

          }
          
        }
        //this.pageArray=this.detaildata.gxsd_book_page.split(',');
        //this.totalcount=json.dataSize;

       // console.log("详细信息："+json.gxsd_book_page);


      },err=>{

      })
      //let hguser=window.sessionStorage.gsetItem('hguser');
      let hguid=window.sessionStorage.getItem('hguid');
      //console.log("详细信息："+hguid);
      //获取收藏数据
      this.$http.get(`${this.$store.state.baseurl}/api/hghomesc/getscvalue?bid=`+this.bid+'&uid='+hguid).then(res=>{
        let json=JSON.parse(res.data);
        //console.log("详细信息："+res.data);
        if(json!=""){
          this.ifsc=json.dataSize;

        }
        
        
      },err=>{

      })
  },
};
</script>

<style scoped lang="scss">
  .table{
      width:500px;
      height: auto;
    }
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  .title{
    font-size: 24px;
    color: #000000;
    text-align: left;
    margin: 20px auto 10px auto;
  }
  .sc-xz-box{
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
    div{
      margin: 5px 10px 5px 10px;
      font-size: 14px;
      color: #946442;
      cursor: pointer;
    }
  }
  .xq-box{
    text-align: left;
    margin-top: 15px;
    span{
      font-size: 18px;
      color: #c60828;
    }
    img{
      width:400px;
      height:20px;
      margin-top: 10px;
    }
  }
  .xq-container{
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 15px;
    text-align: left;
    .xq-row{
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      font-size: 14px;
      margin-top: 15px;
      margin-bottom: 15px;
      .xq-left{
        width: 160px;
        color: #666666;
        text-align: justify;
        text-justify:inter-ideograph;
      }
      .xq-right{
        color: #333333;
        word-break: break-all;
      }
    }
  }
  .dzll-box{
    text-align: left;
    span{
      font-size: 18px;
      color: #c60828;
    }
    img{
      height: 20px;
      width:400px;
    }

  }


  .dzll-container{
    margin: 20px auto 20px auto;
    width:1200px;
    height: 800px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
  
    .dzll-img{
      margin: 12px;
      width: 600px;
      height:760px;
      overflow:auto;
      
      background-color: #eeeeee;
      img{
        width: 530px;
        height:720px;
        margin-left: -20px;
      }

    }
    .dzll-input{
      margin: 12px;
      width:550px;
      height:790px;
      background: #fff;
      overflow:scroll;
      .dzll_content{
        padding: 15px;
        text-align: left;

      }
      

    }
  }
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
  border-style: solid;
  border-color:#cec0b2;
}

.img-view {
    position: relative;
    width: 100%;
    height: 100%;
}

/*遮罩层样式*/
.img-view .img-layer {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    overflow: hidden;
}

/*不限制图片大小，实现居中*/
.img-view .img img {
    max-width: 100%;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1000;
}


</style>

